<script>
export default {
    props: {
        ifactForms: {
            type: Array,
            required: true,
        },
        csrfToken: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            open: true,
            currentJobApplicationId: null,
            ifactFormStatuses: [
                'pending',
                'active',
                'expired',
            ],
            ifactFormDatas: {
                pending: [],
                active: [],
                expired: [],
            },
        }
    },

    mounted() {
        for (let ifactStatus of this.ifactFormStatuses) {
            if (this.ifactForms[ifactStatus] === undefined) {
                this.ifactForms[ifactStatus] = [];
            }

            this.ifactFormDatas[ifactStatus] = this.ifactForms[ifactStatus];
        }
    },
}
</script>

<template>
    <div class="job-application-accordion card">
        <div class="p-4" v-for="(ifactForm, ifactFormKey) in ifactFormDatas" :key="ifactFormKey">
            <div class="grid-x grid-padding-x grid-padding-y border-b">
                <div class="cell shrink">
                    <img src="/img/icons/id-card.svg" alt="Icon" />
                </div>

                <div class="cell auto">
                    <span class="text-site-gray f-15 bold"> {{ ifactFormKey | properCase }} <small class="minutes">({{
            ifactForm.length }})</small></span>
                </div>

                <div class="cell shrink">
                    <a @click="open = ifactFormKey">
                        <i class="fa" :class="open == ifactFormKey ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                    </a>
                </div>

                <div v-show="open === ifactFormKey" class="cell small-12">
                    <template>
                        <div v-for="item in ifactForm" :key="item.id" class="grid-x grid-padding-x job-application">
                            <div class="cell auto job-app-title">
                                {{ item.job_application.job.title }} (#{{ item.job_application.job.requisition_id }})
                            </div>

                            <div class="cell shrink">
                                <a :href="`/candidate/ifact-form/${item.job_application.id}`"
                                    class="button small continue dark">
                                    {{ ifactFormKey !== 'pending' ? 'View' : 'Continue' }}
                                </a>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>